import React from 'react';
import { Database, Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import ScreenshotCard from './ScreenshotCard';

const screenshots = [
  { key: 'tabs', file: 'tabs.webp', wide: true },
  { key: 'internalTrend', file: 'internal-trend.webp' },
  { key: 'internalFinding', file: 'internal-finding.webp' },
  { key: 'reports', file: 'reports.webp', wide: true },
  { key: 'reportSummary', file: 'report-summary.webp' },
  { key: 'notifications', file: 'notifications.webp' }
];

const InternalScan = () => {
  const { t } = useLanguage();

  return (
    <section id="internal-scan" className="py-24 bg-gradient-to-b from-black via-cyan-950/10 to-black relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(1,137,196,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(1,137,196,0.03)_1px,transparent_1px)] bg-[size:50px_50px]" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-cyan-600 to-sky-600 p-4 flex items-center justify-center">
              <Database className="w-10 h-10 text-white" />
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-400 to-sky-500 bg-clip-text text-transparent">
            {t.internalScan.title}
          </h2>
          <p className="text-xl text-gray-400 max-w-4xl mx-auto">
            {t.internalScan.subtitle}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {t.internalScan.features.map((feature, index) => (
            <div
              key={index}
              className="relative group"
            >
              <div className="absolute -inset-1 bg-gradient-to-r from-cyan-600 to-sky-600 rounded-lg blur opacity-20 group-hover:opacity-30 transition duration-300" />
              <div className="relative bg-gradient-to-br from-cyan-950/30 to-sky-950/20 border border-cyan-500/30 rounded-lg p-6 flex items-start gap-4 h-full">
                <Check className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-gray-200 text-lg">{feature}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Screenshots */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {screenshots.map(({ key, file, wide }) => (
            <ScreenshotCard
              key={key}
              file={file}
              wide={wide}
              title={t.internalScan.screenshots[key].title}
              description={t.internalScan.screenshots[key].description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default InternalScan;
